import { render, staticRenderFns } from "./round2.vue?vue&type=template&id=c28a0cc6&"
import script from "./round2.vue?vue&type=script&lang=js&"
export * from "./round2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports